export default "__VITE_ASSET__m3NvXXxq__"